import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { VesselVoyageFormComponent } from "./vessel-voyage-form/vessel-voyage-form.component";
import { VesselVoyageViewComponent } from "./vessel-voyage-view/vessel-voyage-view.component";



const routes: Routes = [
    {
        path: '',
        data: {
            title: 'Vessel Voyage Details',
          },
        component: VesselVoyageViewComponent,
    },
    {
        path:'add',
        data:{
          title:'New Vessel Voyage',
        },
        component:VesselVoyageFormComponent,
    },
    {
        path:'edit/:id',
        data:{
          title:'Edit Vessel Voyage'
        },
        component:VesselVoyageFormComponent,
    }
    
]

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class VesselVoyageRoutingModule { }